import { css, keyframes } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme";

export const contentStyles = (theme: ExactTheme) =>
  css({
    maxWidth: 300,
    backgroundColor: "white",
    padding: 10,
    borderRadius: theme.borderRadiusV2.primary,
    boxShadow: theme.shadowV2.primary,
    color: theme.colorsV2.grey[800],
    zIndex: theme.zIndices.tooltips,
    fontSize: theme.fontSizesV2.body,
    userSelect: "none",
    cursor: "default",
    willChange: "transform, opacity",

    '&[data-state="delayed-open"]': {
      '&[data-side="top"]': { animationName: slideDownAndFade },
      '&[data-side="right"]': { animationName: slideLeftAndFade },
      '&[data-side="bottom"]': { animationName: slideUpAndFade },
      '&[data-side="left"]': { animationName: slideRightAndFade },
    },
  });

const slideUpAndFade = keyframes({
  from: { opacity: 0, transform: "translateY(2px)" },
  to: { opacity: 1, transform: "translateY(0)" },
});

const slideRightAndFade = keyframes({
  from: { opacity: 0, transform: "translateX(-2px)" },
  to: { opacity: 1, transform: "translateX(0)" },
});

const slideDownAndFade = keyframes({
  from: { opacity: 0, transform: "translateY(-2px)" },
  to: { opacity: 1, transform: "translateY(0)" },
});

const slideLeftAndFade = keyframes({
  from: { opacity: 0, transform: "translateX(2px)" },
  to: { opacity: 1, transform: "translateX(0)" },
});
